import { PropsWithChildren } from 'react';

import { LoyaltyChipBadge } from '../../../../../loyalty';
import styles from './VolumeOption.module.css';

interface VolumeOptionProps extends PropsWithChildren {
    isSelected: boolean;
    onClick: () => void;
    isLoyaltyOption?: boolean;
}

export const VolumeOption = ({
    children,
    isSelected,
    onClick,
    isLoyaltyOption,
}: VolumeOptionProps) => {
    return (
        <div
            className={
                `${styles.volume} ${isSelected ? styles.selected : ''}` +
                (isLoyaltyOption ? ` ${styles.loyaltyOption}` : '')
            }
            onClick={onClick}
        >
            {isLoyaltyOption && <LoyaltyChipBadge />}
            {children}
        </div>
    );
};
